import { Modal, Form, Input, Button } from 'antd';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import http from '../Http';
import utils from '../utils';
import { LockOutlined } from '@ant-design/icons';

function PasswordResetor(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);
    const { show, onClose, userId } = props;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            
            const resp = await http.post("user/management/password/reset/do", {
                UserID: encodeURIComponent(userId),
                Password: encodeURIComponent(values.password)
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[PasswordResetor]", e);
                return null;
            });

            setLoading(false);

            if (resp === null || resp.code !== 200) {
                setTip({ 
                    open: true, 
                    severity: "error", 
                    msg: (resp && resp.msg) ? resp.msg : t("reset password error") 
                });
                return;
            }

            setTip({ open: true, severity: "success", msg: t("reset password success") });
            form.resetFields();
            onClose(true);
        } catch (e) {
            console.log("[PasswordResetor]", e);
        }
    };

    return (
        <Modal
            title={t("Reset Password")}
            visible={show}
            onCancel={handleCancel}
            maskClosable={false}
            footer={[
                <Button key="cancel" shape="round" onClick={handleCancel}>
                    {t("Cancel")}
                </Button>,
                <Button key="submit" shape="round" type="primary" loading={loading} onClick={handleSubmit}>
                    {t("Submit")}
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item
                    name="password"
                    label={t("New Password")}
                    rules={[
                        { required: true, message: t("Please input a password") },
                        { min: 6, message: t("Password must be at least 6 characters") }
                    ]}
                    hasFeedback
                >
                    <Input.Password 
                        prefix={<LockOutlined />}
                        placeholder={t("Enter new password")}
                        style={{ borderRadius: '20px' }}
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    label={t("Confirm Password")}
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        { required: true, message: t("Please confirm your password") },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error(t("The two passwords do not match")));
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t("Confirm new password")}
                        style={{ borderRadius: '20px' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default PasswordResetor;
